var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"reset-passwor-page"},[_c('b-loading',{attrs:{"is-full-page":true,"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }